/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { useMutation } from 'react-query';

const useFetchAPI = (onSuccess, onError, api, mutate) => {
    if (mutate) {
        const createMutation = useMutation({
            mutationFn: api,
            onSuccess,
            onError,
        });
        return createMutation;
    }
};

export default useFetchAPI;
